import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { language } = useLanguage();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    '/images/hero/hero-1.webp',
    '/images/hero/hero-2.webp',
    '/images/hero/hero-3.webp',
    '/images/hero/hero-5.webp',
    '/images/hero/hero-4.webp',
    '/images/hero/hero-6.webp',
    '/images/hero/hero-7.webp',
    '/images/hero/hero-8.webp'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Cambia cada 5 segundos

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section id="hero" className="relative h-screen flex items-end justify-center overflow-hidden">
      {/* Background Images with Transition */}
      {images.map((image, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentImageIndex ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={image}
            alt={`Luxury Interior ${index + 1}`}
            className="w-full h-full object-cover"
            style={{ objectPosition: 'center' }}
            loading={index === 0 ? 'eager' : 'lazy'}
            fetchpriority={index === 0 ? 'high' : undefined}
          />
        </div>
      ))}

      {/* H1 SEO heading */}
      <h1
        data-testid="hero-heading"
        className="relative z-10 pb-16 px-6 text-center text-white font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl"
        style={{ textShadow: '0 2px 18px rgba(0,0,0,0.55)' }}
      >
        {language === 'es'
          ? 'Despacho de Arquitectura e Interiorismo en Playa del Carmen y Riviera Maya'
          : 'Architecture & Interior Design Studio in Playa del Carmen and Riviera Maya'}
      </h1>
    </section>
  );
};

export default Hero;